const SortId = {
  STATUS: 'sortByStatus',
  CREATED_AT: 'sortByCreatedAt',
} as const;

export { SortId };
